import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export class Accordion extends AuxiliumComponent {
	constructor() {
		super();

		this.multiple = this.hasAttribute("multiple");

		this.classList.add("accordion__container");
	}

	parsedCallback() {
		if (this.multiple && Browser.GetFlavour() === "gov") {
			this.prepend(document.createElementWithContents("chip-button", "Show all sections", {
				variation: "none",
				className: "accordion--gov-toggle-all",
				icon: "fas fa-chevron-circle-down",
				onclick: () => {
					const open = !!this.querySelector(":scope > chip-accordionitem:not([open])");

					this.querySelectorAll(":scope > chip-accordionitem").forEach(x => open ? x.Open() : x.Close());
				}
			}));
		}
	}

	UpdateState() {
		const btn = this.querySelector(".accordion--gov-toggle-all span");

		if (btn) {
			btn.textContent = this.querySelector(":scope > chip-accordionitem:not([open])") ? "Show all sections" : "Hide all sections";
		}
	}
}